module.exports = __webpack_public_path__ + "static/media/Balmain-Blue-17-5cm-Biker-Destroyed-Denim-Jeans-for-Men-Lyst_thumb.abe29eca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/thumbs/Balmain-Blue-17-5cm-Biker-Destroyed-Denim-Jeans-for-Men-Lyst_thumb.png
// module id = 264
// module chunks = 0